import React from "react";
import ReportDetail from "../ReportDetail";
import StockReport from "./StockReport";

const Stock = () => {
  return (
    <ReportDetail title="stock_report">
      <StockReport />
    </ReportDetail>
  );
};

export default Stock;
